import { toDisplayString as _toDisplayString, createVNode as _createVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, vShow as _vShow, withDirectives as _withDirectives, Fragment as _Fragment } from "vue"
import _imports_0 from '@/app/ui/assets/svg/warning.svg'
import _imports_1 from '@/app/ui/assets/svg/badge-confirmation-general.svg'


const _hoisted_1 = { class: "grid gap-3 text-12px xxl:text-14px grid-cols-4 pt-6" }
const _hoisted_2 = { class: "my-1.5 text-black-lp-200" }
const _hoisted_3 = { class: "my-1.5 text-black-lp-200" }
const _hoisted_4 = { class: "my-1.5 text-black-lp-200" }
const _hoisted_5 = { class: "my-1.5 text-black-lp-200" }
const _hoisted_6 = /*#__PURE__*/_createVNode("div", { class: "py-3 col-span-4" }, [
  /*#__PURE__*/_createVNode("hr")
], -1)
const _hoisted_7 = { class: "flex" }
const _hoisted_8 = { class: "text-12px xxl:text-14px my-2 bg-gray-lp-200 px-3 rounded text-black-lp-200" }
const _hoisted_9 = { class: "text-12px xxl:text-14px my-2 text-black-lp-200" }
const _hoisted_10 = { class: "text-12px xxl:text-14px my-2 text-black-lp-200" }
const _hoisted_11 = { class: "text-12px xxl:text-14px my-2 text-black-lp-200" }
const _hoisted_12 = { class: "text-12px xxl:text-14px my-2 text-black-lp-200" }
const _hoisted_13 = { class: "text-12px xxl:text-14px my-2 text-black-lp-200" }
const _hoisted_14 = /*#__PURE__*/_createVNode("div", { class: "py-6 col-span-4" }, [
  /*#__PURE__*/_createVNode("hr")
], -1)
const _hoisted_15 = { class: "text-12px xxl:text-14px py-4 space-y-2" }
const _hoisted_16 = /*#__PURE__*/_createVNode("img", {
  src: _imports_0,
  class: "w-36 mx-auto",
  alt: "warning"
}, null, -1)
const _hoisted_17 = { class: "pb-2 space-y-2" }
const _hoisted_18 = { class: "font-semibold text-center text-black-lp-200" }
const _hoisted_19 = { class: "text-center text-black-lp-300" }
const _hoisted_20 = { key: 0 }
const _hoisted_21 = { class: "mt-1" }
const _hoisted_22 = { class: "mt-1" }
const _hoisted_23 = { class: "mt-1" }
const _hoisted_24 = { class: "flex flex-row justify-center space-x-4 py-2" }
const _hoisted_25 = { class: "text-12px xxl:text-14px py-4 space-y-2" }
const _hoisted_26 = /*#__PURE__*/_createVNode("img", {
  src: _imports_1,
  class: "w-36 mx-auto",
  alt: "badge-confirmation-general"
}, null, -1)
const _hoisted_27 = { class: "pb-2 space-y-2" }
const _hoisted_28 = { class: "font-semibold text-center text-black-lp-200" }
const _hoisted_29 = { class: "text-center text-black-lp-300" }
const _hoisted_30 = { class: "flex flex-row justify-center space-x-4 py-2" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_DataWrapper = _resolveComponent("DataWrapper")!
  const _component_Select = _resolveComponent("Select")!
  const _component_LpButton = _resolveComponent("LpButton")!
  const _component_ModalForm = _resolveComponent("ModalForm")!
  const _component_LpInput = _resolveComponent("LpInput")!
  const _component_UploadFile = _resolveComponent("UploadFile")!
  const _component_Modal = _resolveComponent("Modal")!

  return (_openBlock(), _createBlock(_Fragment, null, [
    (_ctx.modelValue)
      ? (_openBlock(), _createBlock(_component_ModalForm, {
          key: 0,
          title: _ctx.$t('podDex.updateModalTitle'),
          onClose: _ctx.onClose,
          modalWidth: "w-1/2",
          isFooter: false,
          "data-testid": "incoming-pod-dex-modal-update"
        }, {
          content: _withCtx(() => [
            _createVNode("div", _hoisted_1, [
              _createVNode(_component_DataWrapper, {
                label: _ctx.$t('podDex.update.noStt'),
                class: "col-span-2"
              }, {
                default: _withCtx(() => [
                  _createVNode("div", _hoisted_2, _toDisplayString(_ctx.detailData.sttNo), 1)
                ]),
                _: 1
              }, 8, ["label"]),
              _createVNode(_component_DataWrapper, {
                label: _ctx.$t('podDex.update.totalKoli'),
                class: "col-span-2"
              }, {
                default: _withCtx(() => [
                  _createVNode("div", _hoisted_3, _toDisplayString(_ctx.formatQuantity(_ctx.detailData.totalPiece)), 1)
                ]),
                _: 1
              }, 8, ["label"]),
              _createVNode(_component_DataWrapper, {
                label: _ctx.$t('podDex.update.beratDikenakanBiaya'),
                class: "col-span-2"
              }, {
                default: _withCtx(() => [
                  _createVNode("div", _hoisted_4, _toDisplayString(_ctx.formatWeight(_ctx.detailData.chargeableWeight)) + " Kg ", 1)
                ]),
                _: 1
              }, 8, ["label"]),
              _createVNode(_component_DataWrapper, {
                label: _ctx.$t('podDex.update.biayaCod'),
                class: "col-span-2"
              }, {
                default: _withCtx(() => [
                  _createVNode("div", _hoisted_5, _toDisplayString(_ctx.formatPrice(_ctx.detailData.codAmount)), 1)
                ]),
                _: 1
              }, 8, ["label"]),
              _hoisted_6,
              _createVNode(_component_DataWrapper, {
                label: _ctx.$t('podDex.update.produk'),
                class: "col-span-2"
              }, {
                default: _withCtx(() => [
                  _createVNode("div", _hoisted_7, [
                    _createVNode("div", _hoisted_8, _toDisplayString(_ctx.detailData.productName), 1)
                  ])
                ]),
                _: 1
              }, 8, ["label"]),
              _createVNode(_component_DataWrapper, {
                label: _ctx.$t('podDex.update.komoditas'),
                class: "col-span-2"
              }, {
                default: _withCtx(() => [
                  _createVNode("div", _hoisted_9, _toDisplayString(_ctx.detailData.commodityName), 1)
                ]),
                _: 1
              }, 8, ["label"]),
              _createVNode(_component_DataWrapper, {
                label: _ctx.$t('podDex.update.namaPenerima'),
                class: "col-span-2"
              }, {
                default: _withCtx(() => [
                  _createVNode("div", _hoisted_10, _toDisplayString(_ctx.detailData.recipientName), 1)
                ]),
                _: 1
              }, 8, ["label"]),
              _createVNode(_component_DataWrapper, {
                label: _ctx.$t('podDex.update.alamatPenerima'),
                class: "col-span-2"
              }, {
                default: _withCtx(() => [
                  _createVNode("div", _hoisted_11, _toDisplayString(_ctx.detailData.recipientAddress), 1)
                ]),
                _: 1
              }, 8, ["label"]),
              _createVNode(_component_DataWrapper, {
                label: _ctx.$t('podDex.update.noTelpPenerima'),
                class: "col-span-2"
              }, {
                default: _withCtx(() => [
                  _createVNode("div", _hoisted_12, _toDisplayString(_ctx.detailData.recipientPhoneNumber), 1)
                ]),
                _: 1
              }, 8, ["label"]),
              _createVNode(_component_DataWrapper, {
                label: _ctx.$t('podDex.update.infoKurir'),
                class: "col-span-2"
              }, {
                default: _withCtx(() => [
                  _createVNode("div", _hoisted_13, _toDisplayString(_ctx.detailData.courierName) + " (" + _toDisplayString(_ctx.detailData.courierPhoneNumber) + ") ", 1)
                ]),
                _: 1
              }, 8, ["label"])
            ]),
            _hoisted_14,
            _createVNode("div", {
              class: 
          `flex flex-row justify-between items-center space-y-4 ${
            _ctx.sentSelect ? 'pb-20' : 'pb-8'
          }`
        
            }, [
              _createVNode(_component_DataWrapper, {
                label: _ctx.$t('podDex.update.terkirim'),
                class: "col-span-2"
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_Select, {
                    dataSelect: _ctx.sentList,
                    onOpenSelect: () => _ctx.onOpenSentSelect(true),
                    onCloseSelect: () => _ctx.onOpenSentSelect(false),
                    onChooseSelect: _ctx.onSelectSentType,
                    value: _ctx.form.sentValue,
                    isOpenMenu: _ctx.sentSelect,
                    isShowDefault: false,
                    class: "text-12px xxl:text-14px w-64 my-2"
                  }, null, 8, ["dataSelect", "onOpenSelect", "onCloseSelect", "onChooseSelect", "value", "isOpenMenu"])
                ]),
                _: 1
              }, 8, ["label"]),
              _createVNode(_component_LpButton, {
                disabled: !_ctx.form.sentValue,
                onClick: _ctx.onConfirm,
                customClass: "px-10 py-2",
                textColor: "white",
                title: _ctx.$t('podDex.update.update')
              }, null, 8, ["disabled", "onClick", "title"])
            ], 2)
          ]),
          _: 1
        }, 8, ["title", "onClose"]))
      : _createCommentVNode("", true),
    _withDirectives(_createVNode(_component_ModalForm, {
      modalWidth: "w-6/20",
      isFooter: false,
      isHeader: false,
      isScroll: ""
    }, {
      content: _withCtx(() => [
        _createVNode("div", _hoisted_15, [
          _hoisted_16,
          _createVNode("div", _hoisted_17, [
            _createVNode("div", _hoisted_18, _toDisplayString(_ctx.$t("podDex.update.konfirmasiPerubahan")), 1),
            _createVNode("div", _hoisted_19, _toDisplayString(_ctx.form.sentValue === "yes"
                ? _ctx.$t("podDex.update.confirmMessagePod")
                : _ctx.$t("podDex.update.confirmMessageDex")), 1)
          ]),
          (_ctx.form.sentValue === 'yes')
            ? (_openBlock(), _createBlock("div", _hoisted_20, [
                _createVNode(_component_DataWrapper, {
                  label: _ctx.$t('podDex.update.namaPenerima')
                }, {
                  default: _withCtx(() => [
                    _createVNode("div", _hoisted_21, [
                      _createVNode(_component_LpInput, {
                        modelValue: _ctx.form.receiverName,
                        "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => (_ctx.form.receiverName = $event)),
                        placeholder: _ctx.$t('podDex.update.placeholderNamaPenerima')
                      }, null, 8, ["modelValue", "placeholder"])
                    ])
                  ]),
                  _: 1
                }, 8, ["label"]),
                _createVNode(_component_DataWrapper, {
                  label: _ctx.$t('podDex.update.pilihRelasi')
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_Select, {
                      dataSelect: _ctx.listRecipientRelation,
                      onOpenSelect: _ctx.onOpenSelectRelation,
                      onCloseSelect: _ctx.onCloseSelectRelation,
                      onChooseSelect: _ctx.onSelectRelation,
                      isOpenMenu: _ctx.isOpenSelectRelation,
                      value: _ctx.form.relation,
                      heightOptions: "360px",
                      class: "text-12px xxl:text-14px w-full my-2"
                    }, null, 8, ["dataSelect", "onOpenSelect", "onCloseSelect", "onChooseSelect", "isOpenMenu", "value"])
                  ]),
                  _: 1
                }, 8, ["label"])
              ]))
            : (_openBlock(), _createBlock(_component_DataWrapper, {
                key: 1,
                label: _ctx.$t('podDex.update.alasanTidakTerkirim')
              }, {
                default: _withCtx(() => [
                  _createVNode("div", _hoisted_22, [
                    _createVNode(_component_Select, {
                      dataSelect: _ctx.reasonList,
                      onOpenSelect: () => _ctx.onOpenReasonSelect(true),
                      onCloseSelect: () => _ctx.onOpenReasonSelect(false),
                      onChooseSelect: _ctx.onSelectReasonType,
                      value: _ctx.form.reasonValue,
                      isOpenMenu: _ctx.reasonSelect,
                      isShowDefault: false,
                      heightOptions: "360px",
                      class: "text-12px xxl:text-14px w-full my-2"
                    }, null, 8, ["dataSelect", "onOpenSelect", "onCloseSelect", "onChooseSelect", "value", "isOpenMenu"])
                  ])
                ]),
                _: 1
              }, 8, ["label"])),
          (_ctx.isOtherReason)
            ? (_openBlock(), _createBlock(_component_DataWrapper, {
                key: 2,
                label: _ctx.$t('podDex.update.alasanKendala'),
                fontSize: 14
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_LpInput, {
                    modelValue: _ctx.form.remarks,
                    "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => (_ctx.form.remarks = $event)),
                    type: "textarea",
                    placeholder: _ctx.$t('podDex.update.placeholderAlasan'),
                    textAreaRows: "1",
                    minLength: 10,
                    maxLength: 100,
                    showMaxLength: "",
                    format: _ctx.onlyAcceptedSomeChar
                  }, null, 8, ["modelValue", "placeholder", "format"])
                ]),
                _: 1
              }, 8, ["label"]))
            : _createCommentVNode("", true),
          _createVNode(_component_DataWrapper, {
            label: _ctx.$t('podDex.update.buktiPengiriman'),
            optional: ""
          }, {
            default: _withCtx(() => [
              _createVNode("div", _hoisted_23, [
                _createVNode(_component_UploadFile, {
                  modelValue: _ctx.form.file,
                  "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => (_ctx.form.file = $event)),
                  isClear: _ctx.modelValue,
                  "onUpdate:isClear": _cache[4] || (_cache[4] = ($event: any) => (_ctx.modelValue = $event)),
                  caption: "JPG, PNG, PDF",
                  allowed: "image/jpeg, image/jpg, image/png, application/pdf",
                  isDraggable: false,
                  isMax: false,
                  changeCustom: true,
                  customClass: "py-4"
                }, null, 8, ["modelValue", "isClear"])
              ])
            ]),
            _: 1
          }, 8, ["label"]),
          _createVNode("div", _hoisted_24, [
            _createVNode(_component_LpButton, {
              onClick: _ctx.onBack,
              customClass: "px-10 py-2",
              textColor: "red-lp-100",
              title: _ctx.$t('podDex.update.kembali'),
              outline: ""
            }, null, 8, ["onClick", "title"]),
            _createVNode(_component_LpButton, {
              disabled: _ctx.isDisableConfirm,
              onClick: _ctx.onUpdate,
              customClass: "px-10 py-2 w-32",
              textColor: "white",
              title: _ctx.$t('podDex.update.update')
            }, null, 8, ["disabled", "onClick", "title"])
          ])
        ])
      ]),
      _: 1
    }, 512), [
      [_vShow, _ctx.form.sentValue && _ctx.isConfirm && !_ctx.isModalConfirmationRtsHal]
    ]),
    _withDirectives(_createVNode(_component_ModalForm, {
      modalWidth: "w-6/20",
      isFooter: false,
      isHeader: false,
      isScroll: ""
    }, {
      content: _withCtx(() => [
        _createVNode("div", _hoisted_25, [
          _hoisted_26,
          _createVNode("div", _hoisted_27, [
            _createVNode("div", _hoisted_28, _toDisplayString(_ctx.$t("podDex.update.inginPodDex")), 1),
            _createVNode("div", _hoisted_29, _toDisplayString(_ctx.$t("podDex.update.sttRtsHal")), 1)
          ]),
          _createVNode("div", _hoisted_30, [
            _createVNode(_component_LpButton, {
              onClick: _ctx.onBackRtsHal,
              customClass: "px-10 py-2",
              textColor: "red-lp-100",
              title: _ctx.$t('podDex.update.kembali'),
              outline: ""
            }, null, 8, ["onClick", "title"]),
            _createVNode(_component_LpButton, {
              onClick: _ctx.onUpdateRts,
              customClass: "px-10 py-2 w-32",
              textColor: "white",
              title: _ctx.$t('podDex.update.update')
            }, null, 8, ["onClick", "title"])
          ])
        ])
      ]),
      _: 1
    }, 512), [
      [_vShow, _ctx.isModalConfirmationRtsHal]
    ]),
    _withDirectives(_createVNode(_component_Modal, {
      onSubmit: _ctx.onCloseUpdate,
      title: _ctx.$t('podDex.update.successTitle'),
      message: 
      _ctx.form.sentValue === 'yes'
        ? _ctx.$t('podDex.update.successMessagePod')
        : _ctx.$t('podDex.update.successMessageDex')
    ,
      image: "image-modal-success",
      textSuccess: _ctx.$t('podDex.update.ok'),
      class: "px-8"
    }, null, 8, ["onSubmit", "title", "message", "textSuccess"]), [
      [_vShow, _ctx.isSuccess]
    ])
  ], 64))
}